import { Instance } from 'mobx-state-tree';
import { WebhookSecretDtoModelBase } from './WebhookSecretDtoModel.base';

/* The TypeScript type of an instance of WebhookSecretDtoModel */
export interface WebhookSecretDtoModelType extends Instance<typeof WebhookSecretDtoModel.Type> {}

/* A graphql query fragment builders for WebhookSecretDtoModel */
export { selectFromWebhookSecretDto, webhookSecretDtoModelPrimitives, WebhookSecretDtoModelSelector } from './WebhookSecretDtoModel.base';

/**
 * WebhookSecretDtoModel
 */
export const WebhookSecretDtoModel = WebhookSecretDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
